import { useFormik } from "formik";
import TextInput from "../../../../components/inputs/textInput";
import { useTranslation } from "react-i18next";
import UserIcon from "../../../../icons/userIcon";
import PhoneIcon from "../../../../icons/phoneIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { useState } from "react";
import MailIcon from "../../../../icons/mailIcon";
import MessagePopup from "../../../../components/popups/messagePopup";
import BoardButton from "../../../../components/buttons/boardButton";

const AgentSettings = () => {
  const [save, setSave] = useState(false);
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      setSave(true);
    },
  });

  const { t } = useTranslation();

  const handleCancel = () => {
    formik.resetForm();
  };
  return (
    <main className="relative">
      <h2 className="my-4 text-xl capitalize dark:text-white">{t("accountDetails")}</h2>
      <form onSubmit={formik.handleSubmit}>
        <section className="inputs">
          <TextInput
            icon={<UserIcon />}
            formik={formik}
            label={t("name")}
            name={"name"}
            placeholder={t("enterCustomerName")}
          />
          <TextInput
            icon={<PhoneIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("phone")}
            name={"phone"}
            placeholder={t("enterPhoneNumber")}
          />
        </section>
        <section className="oneInput">
          <TextInput
            icon={<MailIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("email")}
            name={"email"}
            placeholder={t("enterEmail")}
          />
        </section>
        <h2 className="my-4 text-xl capitalize">{t("resetPassword")}</h2>
        <section className="inputs">
          <TextInput
            formik={formik}
            label={t("currentPassword")}
            name={"oldPassword"}
            placeholder={t("enterCurrentPassword")}
            type="password"
          />
          <TextInput
            formik={formik}
            label={t("newPassword")}
            name={"newPassword"}
            placeholder={t("enterNewPassword")}
            type="password"
          />
        </section>
        <section className="oneInput">
          <TextInput
            formik={formik}
            label={t("reEnterPassword")}
            name={"rePassword"}
            placeholder={t("reEnterPassword")}
            type="password"
          />
        </section>
        <div className="flex items-center gap-3">
          <BoardButton secondary bg>
            {t("saveChanges")}
          </BoardButton>
          <BoardButton
            secondary
            border
            text
            className={"border"}
            type="button"
            onClick={handleCancel}
          >
            {t("cancel")}
          </BoardButton>
        </div>
      </form>
      <MessagePopup
        text={t("savedSuccess")}
        icon={<ShipmentDeliveredIcon className="size-20" />}
        state={save}
        setState={setSave}
      />
    </main>
  );
};

export default AgentSettings;
